// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__-dTuT","content":"RecentSearches_content__PZIaC"};